// Thin wrapper around Plausible's custom event API.
// window.plausible is injected by the Plausible script tag (see index.html).
// All calls are silent no-ops when Plausible is not loaded.

export function track(event, props = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.plausible === 'function') {
      window.plausible(event, { props });
    }
  } catch (_) {}
}
